import { useNavigate } from "react-router-dom";
import { Host_APIS } from "../../../libs/apis/host.api";
import { successToaster } from "../../../utils/helpers/common/alert-service";
import { HostProfileDTO } from "../../../utils/helpers/models/host-dtos/host-profile.dto";
import { useState } from "react";

const useHook = () => {
  const navigate = useNavigate();
  const [hostProfile, setHostProfile] = useState<any | null>(null);
  const [businessProfile, setusinessProfile] = useState<HostProfileDTO | null>(
    null
  );

  const uploadFile = async (params: FormData): Promise<string | null> => {
    try {
      const response = await Host_APIS.uploadFile(params);
      const { status = false, message = "", data = null } = response || {};

      if (status && data) {
        // successToaster(message);
        return data;
      }

      return null;
    } catch (error) {
      console.error("Upload failed", error);
      return null;
    }
  };

  const updateProfile = async (body: HostProfileDTO) => {
    const response = await Host_APIS.postUserData(body);
    const { status = false, message = "" } = response || {};

    if (status) {
      successToaster(message);
      return true;
    }
  };

  const updateBusinessProfile = async (body: HostProfileDTO) => {
    const response = await Host_APIS.postBusinessProfileData(body);
    const { status = false, message = "" } = response || {};

    if (status) {
      successToaster(message);
      return true;
    }
  };

  const getHostProfileData = async () => {
    const response = await Host_APIS.getHostProfileData();
    const { status = false, message = "" } = response || {};

    if (status) {
      setHostProfile(response?.data);
      return response.data;
    }
  };

  return {
    uploadFile,
    updateProfile,
    updateBusinessProfile,
    getHostProfileData,
    hostProfile,
  };
};

export default useHook;
